/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import type { PieChartItemData } from './pieChart.types';

/**
 * Returns the nav util for pie chart.
 * @param data
 * @param isRtl
 * @returns
 */
export function getPieChartNavUtils(data: PieChartItemData[], isRtl: boolean) {
  const getNextChartItem = (
    { itemIndex }: { itemIndex: number },
    arrow: 'ArrowLeft' | 'ArrowRight' | 'ArrowDown' | 'ArrowUp'
  ): { itemIndex: number } => {
    let newItemIndex = itemIndex;

    if (
      (isRtl && (arrow === 'ArrowRight' || arrow === 'ArrowUp')) ||
      (!isRtl && (arrow === 'ArrowLeft' || arrow === 'ArrowDown'))
    ) {
      newItemIndex = itemIndex - 1;
    } else {
      newItemIndex = itemIndex + 1;
    }
    return {
      itemIndex: ((newItemIndex % data.length) + data.length) % data.length
    };
  };

  return getNextChartItem;
}
